import React, { useState, PureComponent } from "react";
import { Link, useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import "../App.css";
import Header from "./header";
import SideNav from "./sidenav";
import Back from "../assets/images/arrow2.png";
import User4 from "../assets/images/user4.jpg";
import camera2 from "../assets/images/camera2.png";
import AddMore from "../assets/images/add.png";
import { Button } from "react-bootstrap";
// import TimePicker from 'react-time-picker';
import { useDispatch, useSelector } from "react-redux";
import { getOwnerCategory } from "../redux/actions/authAction";
import { toast } from "react-toastify";
import { useEffect } from "react";
import { getStore, getStoreUpload } from "../redux/actions/storeAction";
import S3FileUpload from "react-s3/lib/ReactS3";
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from "use-places-autocomplete";
import useOnclickOutside from "react-cool-onclickoutside";
import _ from "lodash";
import moment from "moment/moment";
import { s3Config } from "../config/s3bucket";
import { addLeadingZero } from "../utils";
const initialState = {
  imageUploadType: "",
  _id: "",
  storeName: "",
  description: "",
  address: "",
  logo: "",
  banner: [],
  storeCategory: "",
  mapAddress: "",
  openTime: "",
  closeTime: "",
  closeTimePeriod: "",
  openTimePeriod: "",
  serviceType: "",
  overAllDiscount: "",
  minOrderValue: "",
  lat: "",
  long: "",
  errors: {},
  hoursData: [
    {
      time: "00",
      status: false,
    },
    {
      time: "01",
      status: false,
    },
    {
      time: "02",
      status: false,
    },
    {
      time: "03",
      status: false,
    },
    {
      time: "04",
      status: false,
    },
    {
      time: "05",
      status: false,
    },
    {
      time: "06",
      status: false,
    },
    {
      time: "07",
      status: false,
    },
    {
      time: "08",
      status: false,
    },
    {
      time: "09",
      status: false,
    },
    {
      time: "10",
      status: false,
    },
    {
      time: "11",
      status: false,
    },
    {
      time: "12",
      status: false,
    },
  ],
  minutesData: [
    {
      time: "00",
      status: false,
    },
    {
      time: "01",
      status: false,
    },
    {
      time: "02",
      status: false,
    },
    {
      time: "03",
      status: false,
    },
    {
      time: "04",
      status: false,
    },
    {
      time: "05",
      status: false,
    },
    {
      time: "06",
      status: false,
    },
    {
      time: "07",
      status: false,
    },
    {
      time: "08",
      status: false,
    },
    {
      time: "09",
      status: false,
    },
    {
      time: "10",
      status: false,
    },
    {
      time: "11",
      status: false,
    },
    {
      time: "12",
      status: false,
    },
    {
      time: "13",
      status: false,
    },
    {
      time: "14",
      status: false,
    },
    {
      time: "15",
      status: false,
    },
    {
      time: "16",
      status: false,
    },
    {
      time: "17",
      status: false,
    },
    {
      time: "18",
      status: false,
    },
    {
      time: "19",
      status: false,
    },
    {
      time: "20",
      status: false,
    },
    {
      time: "21",
      status: false,
    },
    {
      time: "22",
      status: false,
    },
    {
      time: "23",
      status: false,
    },
    {
      time: "24",
      status: false,
    },
    {
      time: "25",
      status: false,
    },
    {
      time: "26",
      status: false,
    },
    {
      time: "27",
      status: false,
    },
    {
      time: "28",
      status: false,
    },
    {
      time: "29",
      status: false,
    },
    {
      time: "30",
      status: false,
    },
    {
      time: "31",
      status: false,
    },
    {
      time: "32",
      status: false,
    },
    {
      time: "33",
      status: false,
    },
    {
      time: "34",
      status: false,
    },
    {
      time: "35",
      status: false,
    },
    {
      time: "36",
      status: false,
    },
    {
      time: "37",
      status: false,
    },
    {
      time: "38",
      status: false,
    },
    {
      time: "39",
      status: false,
    },
    {
      time: "40",
      status: false,
    },
    {
      time: "41",
      status: false,
    },
    {
      time: "42",
      status: false,
    },
    {
      time: "43",
      status: false,
    },
    {
      time: "44",
      status: false,
    },
    {
      time: "45",
      status: false,
    },
    {
      time: "46",
      status: false,
    },
    {
      time: "47",
      status: false,
    },
    {
      time: "48",
      status: false,
    },
    {
      time: "49",
      status: false,
    },
    {
      time: "50",
      status: false,
    },
    {
      time: "51",
      status: false,
    },
    {
      time: "52",
      status: false,
    },
    {
      time: "53",
      status: false,
    },
    {
      time: "54",
      status: false,
    },
    {
      time: "55",
      status: false,
    },
    {
      time: "56",
      status: false,
    },
    {
      time: "57",
      status: false,
    },
    {
      time: "58",
      status: false,
    },
    {
      time: "59",
      status: false,
    },
    {
      time: "60",
      status: false,
    },
  ],
  TimeZone: [
    {
      time: "AM",
      status: false,
    },
    {
      time: "PM",
      status: false,
    },
  ],
  hourValue: "",
  minuteValue: "",
  timeValue: "",
  closeMinuteValue: "",
  closeHourValue: "",
  SlotModal: false,
};

// const center = {
//   lat: 28.6259,
//   lng: 77.3774,
// };

const MyStoreEdit = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [position, setPosition] = React.useState(null);
  const [iState, updateState] = useState(initialState);
  const [dataa, setData] = useState(false);
  const [checked1, setChecked1] = useState(false);
  const [checked2, setChecked2] = useState(false);
  const [dineDisable, setDineDisable] = useState(false);
  const [serviceTypeSent, setServiceType] = useState([]);
  const {
    closeHourValue,
    closeMinuteValue,
    minuteValue,
    hoursData,
    TimeZone,
    hourValue,
    minutesData,
    closeTimePeriod,
    openTimePeriod,
    serviceType,
    storeName,
    openTime,
    description,
    mapAddress,
    address,
    email,
    mobileNumber,
    logo,
    banner,
    storeCategory,
    imageUploadType,
    AddMapModal,
    closeTime,
    overAllDiscount,
    minOrderValue,
    errors,
    lat,
    long,
    SlotModal,
  } = iState;
  const { categoryList } = useSelector((state) => state.auth);
  let openTimeData1 = [];
  let closeTimeData1 = [];
  openTimeData1.push(`${hourValue}:${minuteValue}`);
  closeTimeData1.push(`${closeHourValue}:${closeMinuteValue}`);

  const handleTime = () => {
    let handleOpenTime = openTime.split(":");
    let handleCloseTime = closeTime.split(":");
    updateState({
      ...iState,
      minuteValue: handleOpenTime[1],
      hourValue: handleOpenTime[0],
      closeHourValue: handleCloseTime[0],
      closeMinuteValue: handleCloseTime[1],
    });
  };

  useEffect(() => {
    handleTime();
  }, [openTimePeriod, closeTimePeriod]);
  const id = JSON.parse(window.localStorage.getItem("storeId"));
  // console.log("id...........>", id)
  const { storeData } = useSelector((state) => state.store);

  useEffect(() => {
    if (!_.isEmpty(storeData)) {
      const updateData = _.cloneDeep(iState);

      updateData.storeName = storeData?.data?.storeName;
      updateData.description = storeData?.data?.description;
      updateData.address = storeData?.data?.address;
      updateData.logo = storeData?.data?.logo;
      updateData.banner = storeData?.data?.banner;
      updateData.long = storeData?.data?.location?.coordinates?.[0];
      updateData.lat = storeData?.data?.location?.coordinates?.[1];
      // updateData.openTime = storeData?.data?.openTime;
      // updateData.closeTime = storeData?.data?.closeTime;
      // updateData.openTimePeriod = storeData?.data?.openTimePeriod;
      // updateData.closeTimePeriod = storeData?.data?.closeTimePeriod;
      updateData.overAllDiscount = storeData?.data?.overAllDiscount;
      updateData.minOrderValue = storeData?.data?.minOrderValue;
      updateData.mobileNumber = storeData?.data?.mobileNumber;
      updateData.email = storeData?.data?.email;
      updateData.storeCategory = storeData?.data?.storeCategory?._id;
      updateData.serviceType = storeData?.data?.serviceType?.map(
        (item) => item,
      );
      let temp1 = storeData?.data?.serviceType?.[0];
      let temp2 = storeData?.data?.serviceType?.[1];
      if (storeData?.data?.storeCategory?.type !== "") {
        setDineDisable(true);
      }

      // console.log("storeData?.data?.storeCategory?.type", storeData?.data?.storeCategory?.type)
      if (temp1 == "Pick-Up") {
        setChecked1(true);
        setServiceType(["Pick-Up"]);
      }
      if (temp1 == "Dine-In") {
        setChecked2(true);
        setServiceType(["Dine-In"]);
      }
      if (temp2 == "Pick-Up") {
        setChecked1(true);
        setServiceType(["Pick-Up"]);
      }
      if (temp1 == "Dine-In" && temp2 == "Pick-Up") {
        setChecked2(true);
        setChecked1(true);
        setServiceType(["Dine-In", "Pick-Up"]);
      }
      if (temp2 == "Dine-In" && temp1 == "Pick-Up") {
        setChecked2(true);
        setChecked1(true);
        setServiceType(["Dine-In", "Pick-Up"]);
      }

      if (temp2 == "Dine-In") {
        setChecked2(true);
        setServiceType(["Dine-In"]);
      }
      if (storeData?.data?.storeCategory?.type == "Food") {
        setDineDisable(true);
      }
      updateState(updateData);
    }

    if (storeData?.data?.workingDays) {
      const apiDays = storeData.data.workingDays;
      const mappedDays = weekDays?.map((day) => {
        const found = apiDays?.find((d) => d.name === day);
        return {
          name: day,
          enabled: found?.enabled || false,
          closeHour: addLeadingZero(found?.closeHour || ""),
          closeMinute: addLeadingZero(found?.closeMinute || ""),
          closePeriod: found?.closePeriod || "",
          openHour: addLeadingZero(found?.openHour || ""),
          openMinute: addLeadingZero(found?.openMinute || ""),
          openPeriod: found?.openPeriod || "",
        };
      });

      setWorkingDays(mappedDays);
    }
  }, [storeData]);

  useEffect(() => {
    dispatch(getOwnerCategory());
    dispatch(getStore({ id }));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    // console.log("targett", e.target.value);
    updateState({
      ...iState,
      [name]: value,
    });
  };

  let handleValidation = () => {
    let error = {};
    let formIsValid = true;

    if (!logo) {
      error.logoError = "*logo  can't be empty";
      formIsValid = false;
    }

    if (!address) {
      error.addressError = "*Address  can't be empty";
      formIsValid = false;
    }

    if (!storeName) {
      error.storeNameError = "*Store Name can't be empty";
      formIsValid = false;
    }
    if (banner.length <= 0) {
      error.bannerError = "*Banner Images can't be empty";
      error.formIsValid = false;
    }

    // if (!openTimeData1.toString()) {
    //   error.openTimeDataError = "Open Time  Data Can't Be Empty";
    //   formIsValid = false;
    // }
    // if (!closeTimeData1.toString()) {
    //   error.closeTimeDataError = "Close Time  Data Can't Be Empty";
    //   formIsValid = false;
    // }
    // if (!openTimePeriod) {
    //   error.openTimeDataError = "Open Time  Data Can't Be Empty";
    //   formIsValid = false;
    // }

    // if (!closeTimePeriod) {
    //   error.closeTimeDataError = "Close Time  Data Can't Be Empty";
    //   formIsValid = false;
    // }

    // if (!openTime) {
    //     error.openTimeError = "*Open Time can't be empty";
    //     formIsValid = false;
    // }

    // if (!closeTime) {
    //     error.closeTimeError = "*Close Time can't be empty";
    //     formIsValid = false;
    // }

    if (!storeCategory) {
      error.storeCategoryError = "*store Category can't be empty";
      formIsValid = false;
    }

    if (!description) {
      error.descriptionError = "*Description can't be empty";
      formIsValid = false;
    }

    if (!overAllDiscount) {
      error.overAllDiscountError = "*Overall Discount can't be empty";
      formIsValid = false;
    } else {
      if (overAllDiscount < 0 || overAllDiscount > 100) {
        error.overAllDiscountError =
          "* Discount should be bewtween 0 to 100% only";
        formIsValid = false;
      }

      if (overAllDiscount < 0) {
        error.overAllDiscountError = " * Overall Discount Can't Be Negative";
        formIsValid = false;
      }
    }

    if (!minOrderValue) {
      error.minOrderValueError = "*Min Order Value can't be empty";
      formIsValid = false;
    } else {
      if (minOrderValue < 1) {
        error.minOrderValueError = "*Minimum One Order Value are allowed";
        formIsValid = false;
      }

      if (minOrderValue < 0) {
        error.minOrderValueError = " * Min Order Value Can't Be Negative";
        formIsValid = false;
      }
    }
    if (dineDisable && !checked1 && !checked2) {
      error.serviceTypeError = "Service Type Can't Be Empty";
      formIsValid = false;
    }
    // if (checked1 && dineDisable) {
    //     error.serviceTypeError = "Service Type Can't Be Empty2";
    //     formIsValid = false;
    // }

    if (!checked1 && !checked2) {
      error.serviceTypeError = "Service Type Can't Be Empty";
      formIsValid = false;
    }

    updateState({
      ...iState,
      errors: error,
    });
    return formIsValid;
  };

  const handleUploaded = (e) => {
    e.preventDefault();
    let formIsValid = handleValidation();
    if (formIsValid) {
      const dataa = {
        _id: id,
        serviceType: serviceTypeSent,
        storeName,
        description,
        address: value.trim(),
        email,
        mobileNumber,
        // closeTimePeriod,
        // openTimePeriod,
        logo,
        banner,
        storeCategory,
        // openTime: openTimeData1.toString(),
        // closeTime: closeTimeData1.toString(),
        overAllDiscount,
        minOrderValue,
        lat,
        long,
        workingDays,
      };
      dispatch(getStoreUpload(dataa))
        .then((res) => {
          if (res.status === 200) {
            navigate("/my-store");
            toast.success(res.message, {
              position: toast.POSITION.TOP_RIGHT,
            });
          } else {
            toast.error(res.message, {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        })
        .catch((err) => {
          const message = err?.response?.data
            ? err?.response?.data?.message
            : "Something went wrong.";
          toast.error(message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        });
    }
  };

  const handleInputChange = (e) => {
    let { value, checked } = e.target;
    if (checked) {
      setServiceType([...serviceTypeSent, value]);
    } else {
      setServiceType(serviceTypeSent.filter((item) => item !== value));
    }
  };
  const handleDropDown = (e) => {
    const ID = e.target.value;
    let nameCat = categoryList.filter((item, index) => item?._id == ID);
    // console.log("nameCat?.type", nameCat);
    if (nameCat?.[0]?.type == "Food") {
      setDineDisable(false);
    }
    if (nameCat?.[0]?.type == "") {
      setServiceType(["pickup"]);
      setDineDisable(true);
      setChecked2(false);
    }
    updateState({
      ...iState,
      storeCategory: e.target.value,
    });
  };

  const onFileHandler = (e, imageType) => {
    // console.log("e.target.files[0]",e.target.files[0])
    // console.log("Imagetye------>", imageType)
    const file = e.target.files[0];
    // console.log("fileee", file);
    if (file) {
      if (
        file.type === "image/jpeg" ||
        file.type === "image/jpg" ||
        file.type === "image/png"
      ) {
        S3FileUpload.uploadFile(file, s3Config)
          .then((data) => {
            // console.log("dattaa", data);
            updateState({ ...iState, logo: data.location });
          })

          .catch((err) => console.error(err));
      } else {
        toast.error("Only formats are allowed: ", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  };

  const updatingBanner = (e, item, index) => {
    const tempBanner = banner;

    for (let x = 0; x < tempBanner.length; x++) {
      if (index == x) {
        tempBanner.splice(x, 1, item);
      }
    }
    // console.log("temp--->", tempBanner)
    updateState({ ...iState, banner: [...tempBanner] });
  };

  const onBannerHandler = (e, imageType, index) => {
    // console.log("tempBanner before", tempBanner)

    const file = e.target.files[0];

    if (file) {
      if (
        file.type === "image/jpeg" ||
        file.type === "image/jpg" ||
        file.type === "image/png"
      ) {
        S3FileUpload.uploadFile(file, {
          bucketName: "bayinn",
          dirName: imageType,
          region: "us-east-1",
          accessKeyId: "AKIASEVRSUZK36B4AK6A",
          secretAccessKey: "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",
        })
          .then((data) => {
            updatingBanner(e, data.location, index);
          })

          .catch((err) => console.error(err));
      } else {
        toast.error("Only formats are allowed: ", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  };

  // ****************AutoComplete functions***************

  const {
    ready,
    value,
    suggestions: { status, data },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete({
    requestOptions: {
      /* Define search scope here */
    },
    debounce: 300,
  });

  const ref = useOnclickOutside(() => {
    // When user clicks outside of the component, we can dismiss
    // the searched suggestions by calling this method
    clearSuggestions();
  });

  const handleInput = (e) => {
    // Update the keyword of the input element

    setValue(e.target.value);
    updateState({ ...iState, address: e.target.value });
  };

  const handleSelect =
    ({ description }) =>
    () => {
      updateState({ ...iState, address: description });
      // When user selects a place, we can replace the keyword without request data from API
      // by setting the second parameter to "false"
      // console.log("Deskcription--->",description)
      setValue(description, false);

      clearSuggestions();

      // Get latitude and longitude via utility functions
      getGeocode({ address: description }).then((results) => {
        const { lat, lng } = getLatLng(results[0]);
        // console.log("📍 Coordinates: ", { lat, lng });
        updateState((prev) => ({ ...prev, lat: lat, long: lng }));
        setPosition({ lat, lng });
        //   map?.setCenter(position)
      });
    };

  const renderSuggestions = () =>
    data.map((suggestion) => {
      // console.log(suggestion);
      const {
        place_id,
        structured_formatting: { main_text, secondary_text },
      } = suggestion;

      return (
        <li key={place_id} onClick={handleSelect(suggestion)}>
          <strong>{main_text}</strong> <small>{secondary_text}</small>
        </li>
      );
    });

  const weekDays = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  const [workingDays, setWorkingDays] = useState(
    weekDays.map((day) => ({
      name: day,
      enabled: true,
      closeHour: "",
      closeMinute: "",
      closePeriod: "",
      openHour: "",
      openMinute: "",
      openPeriod: "",
    })),
  );

  const toggleDay = (index) => {
    const updated = [...workingDays];
    updated[index].enabled = !updated[index].enabled;
    setWorkingDays(updated);
  };

  const handleSlotModalShow = () => {
    updateState((prev) => ({ ...prev, SlotModal: true }));
  };

  const handleSlotModalClose = () => {
    updateState((prev) => ({ ...prev, SlotModal: false }));
  };

  const [slotData, setSlotData] = useState({
    openHour: "",
    openMinute: "",
    openPeriod: "",
    closeHour: "",
    closeMinute: "",
    closePeriod: "",
  });

  const handleSlotChange = (e) => {
    const { name, value } = e.target;

    setSlotData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSlotSubmit = () => {
    const updatedDays = workingDays.map((day) => ({
      ...day,
      openHour: slotData.openHour,
      openMinute: slotData.openMinute,
      openPeriod: slotData.openPeriod,
      closeHour: slotData.closeHour,
      closeMinute: slotData.closeMinute,
      closePeriod: slotData.closePeriod,
    }));

    setWorkingDays(updatedDays);
    handleSlotModalClose();
  };

  return (
    <div>
      <Header />
      <SideNav />
      <div class="WrapperArea">
        <div class="WrapperBox">
          <div class="TitleBox">
            <div>
              <h4 class="Title">
                <Link to="/my-store">
                  {" "}
                  <img src={Back} />
                </Link>
                Edit Store
              </h4>
            </div>
          </div>
          <div class="Small-Wrapper">
            <div class="CommonForms">
              <div className="form-group">
                <div class="UploadCategory">
                  <div class="UploadImagesLeft">
                    {logo ? (
                      <img src={logo} />
                    ) : (
                      <p>
                        <i className="fa fa-upload"></i> Upload Logo Image
                      </p>
                    )}
                    {/* <p><i className="fa fa-upload"></i> Upload Logo Image</p> */}

                    <input
                      type="file"
                      className="form-control "
                      name="logo"
                      onChange={(e) => onFileHandler(e, "logo")}
                      onClick={(e) => e.target.value == null}
                    />
                  </div>
                </div>
                <span
                  className="Error"
                  style={{ color: "red", fontSize: "12px" }}
                >
                  {errors.logoError}
                </span>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label>Store Name</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Enter Name"
                      name="storeName"
                      value={storeName}
                      onChange={handleChange}
                    />
                    <span
                      className="Error"
                      style={{ color: "red", fontSize: "12px" }}
                    >
                      {errors.storeNameError}
                    </span>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label>Mobile Number</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Enter Mobile Number"
                      name="mobileNumber"
                      value={mobileNumber}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label>Email Address</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Enter Email Address"
                      name="email"
                      value={email}
                      onChange={handleChange}
                      disabled
                    />
                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="form-group">
                    <label>Address</label>
                    {/* <input type="search" className="form-control" placeholder="Search Address..." name="address" value={address} onChange={handleChange} /> */}
                    <div ref={ref}>
                      <input
                        className="form-control"
                        value={address ?? value}
                        onChange={handleInput}
                        disabled={!ready}
                        placeholder="Search Address..."
                      />
                      {/* We can use the "status" to decide whether we should display the dropdown or not */}
                      {status === "OK" && <ul>{renderSuggestions()}</ul>}
                    </div>
                    {/* *********************MAP ********************** */}

                    {/* <AutoCompleteInput/> */}

                    <span
                      className="Error"
                      style={{ color: "red", fontSize: "12px" }}
                    >
                      {errors.addressError}
                    </span>
                  </div>
                </div>
                <div className="col-sm-12">
                  <label>Store Banners</label>
                  <div className="StoreBanners">
                    <ul>
                      <li>
                        <div className="UploadImages">
                          {banner?.[0] ? (
                            <img src={banner[0]} />
                          ) : (
                            <>
                              <span>
                                {" "}
                                <img src={camera2} />
                              </span>
                              <h6>Add Banner images</h6>
                            </>
                          )}
                          <input
                            type="file"
                            onChange={(e) => onBannerHandler(e, "banners", 0)}
                            onClick={(e) => e.target.value == null}
                          />
                        </div>
                      </li>
                      <li>
                        <div className="UploadImages">
                          {banner?.[1] ? (
                            <img src={banner[1]} />
                          ) : (
                            <>
                              <span>
                                {" "}
                                <img src={camera2} />
                              </span>
                              <h6>Add Banner images</h6>
                            </>
                          )}
                          <input
                            type="file"
                            onChange={(e) => onBannerHandler(e, "banners", 1)}
                            onClick={(e) => e.target.value == null}
                          />
                        </div>
                      </li>
                      <li>
                        <div className="UploadImages">
                          {banner?.[2] ? (
                            <img src={banner[2]} />
                          ) : (
                            <>
                              <span>
                                {" "}
                                <img src={camera2} />
                              </span>
                              <h6>Add Banner images</h6>
                            </>
                          )}

                          <input
                            type="file"
                            onChange={(e) => onBannerHandler(e, "banners", 2)}
                            onClick={(e) => e.target.value == null}
                          />
                        </div>
                      </li>
                    </ul>
                    <span
                      className="Error"
                      style={{ color: "red", fontSize: "12px" }}
                    >
                      {errors.bannerError}
                    </span>
                  </div>
                </div>
                <button
                  type="button"
                  className="btn btn-primary mb-3"
                  onClick={handleSlotModalShow}
                >
                  + Add Time Slot
                </button>

                <div class="col-sm-12">
                  <div class="form-group">
                    <label>Operational Hours</label>
                    <div className="DosageBox">
                      <div className="row">
                        {workingDays.map((day, index) => (
                          <div className="col-12 mb-3" key={index}>
                            <div className="row align-items-center">
                              {/* Day name + toggle */}
                              <div className="col-sm-2 d-flex align-items-center justify-content-between">
                                <strong>{day.name}</strong>
                                <input
                                  type="checkbox"
                                  checked={day.enabled}
                                  onChange={() => toggleDay(index)}
                                />
                              </div>

                              {/* Opening time */}
                              <div className="col-sm-5">
                                <div className="form-group">
                                  <label>Opening time</label>
                                  <div className="TimeMain">
                                    <div className="HoverBox">
                                      <select
                                        className="form-control"
                                        value={day.openHour}
                                        disabled={!day.enabled}
                                        onChange={(e) => {
                                          const updated = [...workingDays];
                                          updated[index].openHour =
                                            e.target.value;
                                          setWorkingDays(updated);
                                        }}
                                      >
                                        <option value="">Select Hours</option>
                                        {hoursData.map((ele) => (
                                          <option
                                            key={ele.time}
                                            value={ele.time}
                                          >
                                            {ele.time}
                                          </option>
                                        ))}
                                      </select>
                                    </div>

                                    <div className="MinutesBox">
                                      <select
                                        className="form-control"
                                        value={day.openMinute}
                                        disabled={!day.enabled}
                                        onChange={(e) => {
                                          const updated = [...workingDays];
                                          updated[index].openMinute =
                                            e.target.value;
                                          setWorkingDays(updated);
                                        }}
                                      >
                                        <option value="">Select Minutes</option>
                                        {minutesData.map((ele) => (
                                          <option
                                            key={ele.name}
                                            value={ele.name}
                                          >
                                            {ele.time}
                                          </option>
                                        ))}
                                      </select>
                                    </div>

                                    <div className="TimeBox">
                                      <select
                                        className="form-control"
                                        value={day.openPeriod}
                                        disabled={!day.enabled}
                                        onChange={(e) => {
                                          const updated = [...workingDays];
                                          updated[index].openPeriod =
                                            e.target.value;
                                          setWorkingDays(updated);
                                        }}
                                      >
                                        <option value="">Select</option>
                                        {TimeZone.map((ele) => (
                                          <option
                                            key={ele.name}
                                            value={ele.name}
                                          >
                                            {ele.time}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Closing time */}
                              <div className="col-sm-5">
                                <div className="form-group">
                                  <label>Closing time</label>
                                  <div className="TimeMain">
                                    <div className="HoverBox">
                                      <select
                                        className="form-control"
                                        value={day.closeHour}
                                        disabled={!day.enabled}
                                        onChange={(e) => {
                                          const updated = [...workingDays];
                                          updated[index].closeHour =
                                            e.target.value;
                                          setWorkingDays(updated);
                                        }}
                                      >
                                        <option value="">Select Hours</option>
                                        {hoursData.map((ele) => (
                                          <option
                                            key={ele.time}
                                            value={ele.time}
                                          >
                                            {ele.time}
                                          </option>
                                        ))}
                                      </select>
                                    </div>

                                    <div className="MinutesBox">
                                      <select
                                        className="form-control"
                                        value={day.closeMinute}
                                        disabled={!day.enabled}
                                        onChange={(e) => {
                                          const updated = [...workingDays];
                                          updated[index].closeMinute =
                                            e.target.value;
                                          setWorkingDays(updated);
                                        }}
                                      >
                                        <option value="">Select Minutes</option>
                                        {minutesData.map((ele) => (
                                          <option
                                            key={ele.name}
                                            value={ele.name}
                                          >
                                            {ele.time}
                                          </option>
                                        ))}
                                      </select>
                                    </div>

                                    <div className="TimeBox">
                                      <select
                                        className="form-control"
                                        value={day.closePeriod}
                                        disabled={!day.enabled}
                                        onChange={(e) => {
                                          const updated = [...workingDays];
                                          updated[index].closePeriod =
                                            e.target.value;
                                          setWorkingDays(updated);
                                        }}
                                      >
                                        <option value="">Select</option>
                                        {TimeZone.map((ele) => (
                                          <option
                                            key={ele.name}
                                            value={ele.name}
                                          >
                                            {ele.time}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="form-group">
                    <label>Store Category</label>
                    <select
                      className="form-control"
                      name="storeCategory"
                      value={storeCategory}
                      onChange={handleDropDown}
                      disabled
                    >
                      <option value="">Select Category</option>
                      {categoryList?.length > 0 &&
                        categoryList?.map((item, i) => {
                          return (
                            <option value={item._id}>
                              {item.category_name}
                            </option>
                          );
                        })}
                    </select>
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {errors.storeCategoryError}
                    </span>
                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="form-group">
                    <label>Description</label>
                    <textarea
                      className="form-control"
                      rows="5"
                      name="description"
                      value={description}
                      onChange={handleChange}
                    >
                      Add Description....
                    </textarea>
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {errors.descriptionError}
                    </span>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group ">
                    <label>Select Service</label>
                    {/* <div className="CheckDiv">

                                            <label class="Checkbox">Pick-Up
                                                <input type="checkbox" name="PICKUP" checked={checked1} value={"pickup"} onChange={(e) => {
                                                    setChecked1(!checked1);
                                                    handleInputChange(e);
                                                }} />
                                                <span class="checkmark"></span>
                                            </label>


                                            {dineDisable && (<label class="Checkbox">Dine-In
                                                <input type="checkbox" name="DINE-IN" checked={checked2} value={"Dine-in"} onChange={(e) => {
                                                    setChecked2(!checked2);
                                                    handleInputChange(e);
                                                }} />
                                                <span class="checkmark"></span>
                                            </label>)}
                                            
                                        </div> */}
                    <div className="CheckDiv">
                      <label class="Checkbox">
                        Pick-Up
                        <input
                          type="checkbox"
                          name="PICKUP"
                          checked={checked1}
                          value={"Pick-Up"}
                          onChange={(e) => {
                            setChecked1(!checked1);
                            handleInputChange(e);
                          }}
                        />
                        <span class="checkmark"></span>
                      </label>

                      {dineDisable && (
                        <>
                          <label class="Checkbox">
                            Dine-In
                            <input
                              type="checkbox"
                              name="DINE-IN"
                              checked={checked2}
                              value={"Dine-In"}
                              onChange={(e) => {
                                setChecked2(!checked2);
                                handleInputChange(e);
                              }}
                            />
                            <span class="checkmark"></span>
                          </label>
                        </>
                      )}
                    </div>
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {errors.serviceTypeError}
                    </span>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label>Overall Discount in % (All Products)</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="20%"
                      name="overAllDiscount"
                      value={overAllDiscount}
                      onChange={handleChange}
                    />
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {errors.overAllDiscountError}
                    </span>
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="form-group">
                    <label>Min Order Value</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="$334"
                      name="minOrderValue"
                      value={minOrderValue}
                      onChange={handleChange}
                    />
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {errors.minOrderValueError}
                    </span>
                  </div>
                </div>
              </div>
              <div class="ButtonMain ">
                {/* <Link to="/my-store" class="Button AddButton">Update</Link> */}
                <button onClick={handleUploaded} class="Button AddButton">
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={SlotModal}
        onHide={handleSlotModalClose}
        centered
        className="ModalBox"
      >
        <Modal.Body>
          <div className="optModal">
            {/* Close button */}
            <button className="CloseModal" onClick={handleSlotModalClose}>
              ×
            </button>

            <h3 className="text-center mb-4">Add Slot</h3>

            <div className="col-sm-12">
              <div className="form-group">
                <label>Operational Hours</label>

                <div className="DosageBox">
                  <div className="row">
                    <div className="col-12 mb-3">
                      <div className="row align-items-center">
                        {/* Opening time */}
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label>Opening time</label>
                            <div className="TimeMain">
                              <div className="HoverBox">
                                <select
                                  className="form-control"
                                  name="openHour"
                                  value={slotData.openHour}
                                  onChange={handleSlotChange}
                                >
                                  <option value="">Select Hours</option>
                                  {hoursData.map((ele) => (
                                    <option key={ele.time} value={ele.time}>
                                      {ele.time}
                                    </option>
                                  ))}
                                </select>
                              </div>

                              <div className="MinutesBox">
                                <select
                                  className="form-control"
                                  name="openMinute"
                                  value={slotData.openMinute}
                                  onChange={handleSlotChange}
                                >
                                  <option value="">Select Minutes</option>
                                  {minutesData.map((ele) => (
                                    <option key={ele.name} value={ele.name}>
                                      {ele.time}
                                    </option>
                                  ))}
                                </select>
                              </div>

                              <div className="TimeBox">
                                <select
                                  className="form-control"
                                  name="openPeriod"
                                  value={slotData.openPeriod}
                                  onChange={handleSlotChange}
                                >
                                  <option value="">Select</option>
                                  {TimeZone.map((ele) => (
                                    <option key={ele.name} value={ele.name}>
                                      {ele.time}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Closing time */}
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label>Closing time</label>
                            <div className="TimeMain">
                              <div className="HoverBox">
                                <select
                                  className="form-control"
                                  name="closeHour"
                                  value={slotData.closeHour}
                                  onChange={handleSlotChange}
                                >
                                  <option value="">Select Hours</option>
                                  {hoursData.map((ele) => (
                                    <option key={ele.time} value={ele.time}>
                                      {ele.time}
                                    </option>
                                  ))}
                                </select>
                              </div>

                              <div className="MinutesBox">
                                <select
                                  className="form-control"
                                  name="closeMinute"
                                  value={slotData.closeMinute}
                                  onChange={handleSlotChange}
                                >
                                  <option value="">Select Minutes</option>
                                  {minutesData.map((ele) => (
                                    <option key={ele.name} value={ele.name}>
                                      {ele.time}
                                    </option>
                                  ))}
                                </select>
                              </div>

                              <div className="TimeBox">
                                <select
                                  className="form-control"
                                  name="closePeriod"
                                  value={slotData.closePeriod}
                                  onChange={handleSlotChange}
                                >
                                  <option value="">Select</option>
                                  {TimeZone.map((ele) => (
                                    <option key={ele.name} value={ele.name}>
                                      {ele.time}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Submit button */}
            <div className="ModalButton mt-4">
              <button className="Button w-100" onClick={handleSlotSubmit}>
                Submit
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};
export default MyStoreEdit;
